<!-- 技术协助 -->
<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick"  size="small" v-model="keywordFilter" clearable placeholder="名称/联系电话/联系地址"
             style="width: 200px; margin-right:3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectServiceDatetime" placeholder="选择日期"
                  style="margin-right: 3px; width: 200px;"></DatePicker>
      <Button size="small" type="primary" @click="onFilterClick">查询</Button>
      <Dropdown size="small" style="margin-right: 3px" @on-click="DropdownonFilterClick">
        <Button  size="small" type="primary">
          <!--          查询-->
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="createDatetime">创建时间</DropdownItem>
          <DropdownItem name="maintainDatetime">完成时间</DropdownItem>
          <DropdownItem name="bookingDatetime">预约时间</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="addTechnicalAssistanceModal=true">添加技术协助</Button>
      <!--<Button type="primary" size="small" @click="onTest">测试</Button>-->
<!--      <Button type="primary" size="small" @click="onDownloadTable">导出Excel</Button>-->
      <Button type="primary" size="small" @click="FAQmodal = true">异常自查</Button>
    </Row>

    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)">
          </Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
              @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>

    <add-technical-assistance-modal v-model="addTechnicalAssistanceModal" :initValue="addTechnicalAssistanceId" @on-success="onModifySuccess"></add-technical-assistance-modal>
    <technical-assistance-confirm-assistance-modal v-model="technicalAssistanceConfirmAssistanceModal" :initValue="technicalAssistanceConfirmAssistanceId" @on-success="onModifySuccess"></technical-assistance-confirm-assistance-modal>

    <f-a-qmodal v-model="FAQmodal" :initValue="FAQId"></f-a-qmodal>

  </div>
</template>

<script>

import AddTechnicalAssistanceModal from '@/view/om/components/add-technical-assistance-modal'
import TechnicalAssistanceConfirmAssistanceModal from '@/view/om/components/technical-assistance-confirm-assistance-modal'
import FAQmodal from '@/view/om/technicalassistance/components/FAQ-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'

export default {
  name: 'technical-assistance.vue',
  components: {
    AddTechnicalAssistanceModal,
    TechnicalAssistanceConfirmAssistanceModal,
    FAQmodal
  },
  data () {
    return {
      // 增加技术协助
      addTechnicalAssistanceModal: false,
      addTechnicalAssistanceId: null,

      // 技术协助处理
      technicalAssistanceConfirmAssistanceModal: null,
      technicalAssistanceConfirmAssistanceId: null,

      // 查询条件：订单状态
      stateFilter: null,
      // 查询条件：时间
      FilterClickFilter: null,

      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 模糊查询关键词
      keywordFilter: null,
      // 表格显示行数
      pageFilter: 30,
      // 分页选项
      pagesizeopts: [30, 50, 100, 200],
      // 表格高度
      tableHeight: 160,
      // 分页页码
      pageIndex: 1,
      // 排序方式
      sort: null,
      // 加载动画
      listLoadding: false,
      // 查询时间范围
      selectServiceDatetime: [],

      columns: [
        // {
        //   title: '订单号',
        //   resizable: true,
        //   key: 'orderNum',
        //   sortable: 'custom',
        //   width: 180
        // },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let vin = ''
            if (params.row.vehicleInfo) {
              registrationNum = params.row.vehicleInfo.registrationNum === null ? '无' : params.row.vehicleInfo.registrationNum
              vin = params.row.vehicleInfo.vin === null ? '无' : params.row.vehicleInfo.vin
            }
            return h('div', [
              h('div', '车牌:' + registrationNum),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: '客户/分组名',
          resizable: true,
          key: 'vehicleInfo.vehicleInfoGroupId',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            let display = []
            if (params.row.vehicleInfo) {
              if (params.row.vehicleInfo.clientInfo) {
                display.push(h('div', '客户信息:' + params.row.vehicleInfo.clientInfo.name + '(' + params.row.vehicleInfo.clientInfo.phoneNum + ')'))
              } else {
                display.push(h('div', '客户信息:无'))
              }
              if (params.row.vehicleInfo.vehicleInfoGroup) {
                display.push(h('div', '分组:' + params.row.vehicleInfo.vehicleInfoGroup.name))
              } else {
                display.push(h('div', '分组:无'))
              }
              return h('div', display)
            }
          }
        },
        {
          title: '加急订单',
          resizable: true,
          key: 'urgent',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          render: (h, params) => {
            const urgent = params.row.urgent
            if (urgent != null) {
              if (urgent) {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'error'
                    }
                  }, '加急')
                ])
              } else {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'blue'
                    }
                  }, '普通')
                ])
              }
            }
          }
        },
        {
          title: '订单状态',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '异常', value: -1 },
            { label: '作废', value: 0 },
            { label: '处理', value: 1 },
            { label: '观察', value: 2 },
            { label: '完成', value: 3 },
            { label: '回访', value: 4 }
          ],
          filterMultiple: true,
          filteredValue: [1, 2, 3, 4],
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            let step = null
            if (params.row.step != null) {
              step = params.row.step.state
            } else {
              step = 1
            }
            if (state === 1) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待处理')
              } else if (step === 2) {
                return h('div', '已处理')
              } else if (step === 3) {
                return h('div', '处理失败')
              }
            } else if (state === 2) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待观察')
              } else if (step === 2) {
                return h('div', '观察中')
              } else if (step === 3) {
                return h('div', '处理失败')
              }
            } else if (state === 3) {
              return h('div', '完成')
            } else if (state === 0) {
              return h('div', '作废')
            } else if (state === -1) {
              return h('div', '异常')
            } else if (state === 4) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待回访')
              } else if (step === 2) {
                return h('div', '回访成功')
              } else if (step === 3) {
                return h('div', '回访失败')
              }
            }
          }
        },
        {
          title: '结果',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.step != null) {
              if (params.row.step.result) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, params.row.step.result)
              } else {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '无')
              }
            }
          }
        },
        {
          title: '问题概况',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'question',
          width: 180
        },
        {
          title: '结果',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.step != null) {
              if (params.row.step.result) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, params.row.step.result)
              } else {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '无')
              }
            }
          }
        },
        {
          title: '观察时间',
          resizable: true,
          key: 'observationDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.observationDatetime) {
              let d = new Date(params.row.observationDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '协助完成时间',
          resizable: true,
          key: 'assistanceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.assistanceDatetime) {
              let d = new Date(params.row.assistanceDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName != null) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName != null) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name != null) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'remark',
          width: 180
        },
        {
          title: '车辆信息备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'remark',
          width: 180,
          render: function (h, params) {
            let texts = ''
            if (params.row.vehicleInfo.remark) {
              texts = params.row.vehicleInfo.remark

              return h('Tooltip', {
                props: {
                  placement: 'bottom-start'
                }
              }, [texts,
                h('span', {
                  slot: 'content',
                  style: {
                    whiteSpace: 'normal',
                    wordBreak: 'break-all'
                  }
                }, texts)
              ])
            }
          }
        },
        {
          title: '车辆信息历史记录',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'historyRecord',
          width: 200,
          render: function (h, params) {
            let texts = ''
            if (params.row.vehicleInfo.historyRecord) {
              texts = params.row.vehicleInfo.historyRecord

              return h('Tooltip', {
                props: {
                  placement: 'bottom-start'
                }
              }, [texts,
                h('span', {
                  slot: 'content',
                  style: {
                    whiteSpace: 'normal',
                    wordBreak: 'break-all'
                  }
                }, texts)
              ])
            }
          }

        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 300,
          fixed: 'right',
          render: (h, params) => {
            let display = []

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.vehicleInfoId
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '车辆信息')
            )

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.technicalAssistanceConfirmAssistanceId = params.row.id
                    this.technicalAssistanceConfirmAssistanceModal = true
                  }
                }
              }, '协助处理')
            )

            if (params.row.state != 0) {
              // console.log('未完成')

              display.push(
                h('Dropdown', {
                  props: {
                    trigger: 'click',
                    transfer: true
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {}
                },
                [
                  h('Button', '更多'),
                  h(
                    'DropdownMenu',
                    {
                      slot: 'list'
                    },
                    [
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.maintainVehiclePictureModalId = params.row.id
                            this.maintainVehiclePictureModal = true
                          }
                        }
                      }, '图片管理'),
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.maintainOrderAddToRemarkModal = true
                            this.maintainOrderAddToRemarkId = params.row.id
                          }
                        }
                      }, '追加备注'),
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.$Modal.confirm({
                              title: '提示',
                              content: '<p>确认作废</p>',
                              onOk: () => {
                                store.dispatch('MaintainOrderServ_Cancel', {
                                  params: { id: params.row.id }
                                }).then(() => {
                                  this.$Message.success('确认作废完成')
                                  this.onModifySuccess()
                                }).catch(err => {
                                  this.$Message.error(err)
                                })
                              },
                              onCancel: () => {

                              }
                            })
                          }
                        }
                      }, '作废订单')
                    ]
                  )
                ]
                )
              )
            }

            return h('div', display)
          }
        }
      ], // cloumn

      FAQmodal: false,
      FAQId: null
    }
  },
  methods: {
    /**
         * 表格右键回调
         */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
         * 右键菜单点击回调
         */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    //  模糊查询方向
    onFilterClick (name) {
      if (name != null) {
        this.FilterClickFilter = null
        this.setPage(1)
      }
    },
    DropdownonFilterClick (name) {
      this.FilterClickFilter = name
      this.setPage(1)
    },
    // table排序
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    // 查询分页
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('updateDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [
          genQueryParam('state', 'EQ', 1),
          genQueryParam('state', 'EQ', 2),
          genQueryParam('state', 'EQ', 3),
          genQueryParam('state', 'EQ', 4)
        ]
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.fileReadyFilter) {
        queryParams.push(this.fileReadyFilter)
      }
      if (this.businessUserFilter) {
        qo2 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo3 = this.billTypeFilter
      }
      if (this.selectServiceDatetime[0] && this.selectServiceDatetime[1]) {
        let startDatetime = new Date(this.selectServiceDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectServiceDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        if (this.FilterClickFilter != null) {
          queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
        } else {
          queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
        }
      } else {

      }

      store.dispatch('TechnicalAssistanceServ_GetMyUserGroupPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    //  组件成功回调方法
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    }
  },
  computed: {
    // computeCol() {
    //   let columns = this.columns
    //   columns = columns.filter(col => {
    //     for (var i = 0; i < this.columnsDisplay.length; i++) {
    //       if (this.columnsDisplay[i] === col.title) {
    //         return true
    //       }
    //     }
    //     return false
    //   })
    //   return columns
    // },
    totalElements () {
      if (store.getters.get_TechnicalAssistance_GetMyUserGroupPageResult) {
        return store.getters.get_TechnicalAssistance_GetMyUserGroupPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_TechnicalAssistance_GetMyUserGroupPageResult) {
        return store.getters.get_TechnicalAssistance_GetMyUserGroupPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_TechnicalAssistance_GetMyUserGroupPageResult) {
        return store.getters.get_TechnicalAssistance_GetMyUserGroupPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>

</style>
